import React from 'react';

import Home from './Home'
import  NavBar  from './NavBar';
import Footer from './footer';
import  Contact  from './Contact';
import App from './App.js';
import AdminTechnology from './AdminTechnology.js';
import AdminTasks from './AdminTasks.js';
import AdminTaskHeader from './AdminTaskHeader.js';
import AdminTopics from './AdminTopics.js';
import AdminTopicTechMapping from './AdminTopicTechMapping.js';
import AdmindefaultTopicTechMapping from './AdmindefaultTopicTechMapping.js';
import { Route, Link, BrowserRouter as Router } from 'react-router-dom';


export const Routess = () => {
  return (
    <div class="wrapper">
      <NavBar />
      <Router>

      <Route exact path = "/" component = {App} />
      

      <Route path="/Home" component={Home} />

      <Route path="/Contact" component={Contact} />

      <Route path="/AdminTechnology" component={AdminTechnology} />

      <Route path="/AdminTaskHeader" component={AdminTaskHeader} />

      <Route path="/AdminTasks" component={AdminTasks} />

      <Route path="/AdminTopics" component={AdminTopics} />

      <Route path="/AdminTopicTechMapping" component={AdminTopicTechMapping} />

      <Route path="/AdmindefaultTopicTechMapping" component={AdmindefaultTopicTechMapping} />
      </Router>
      <Footer/>
    </div>
  );
};